import React, { useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CommonTabs from "../../../Components/Common Components/CommonTabs";
import CounsellorDateContext from "./CounsellorDateContext";
import { Colors } from "../../../Styles/Colors";

const CounsellorHomeWrapper = (props) => {
    const { List, selectedTab, history } = props;
    const [filterDate, setFilterDate] = useState(dayjs());

    const datePicker = (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                value={filterDate}
                inputFormat="DD-MM-YYYY"
                views={["year", "month", "day"]}
                onChange={(newDate) => newDate && setFilterDate(dayjs(newDate))}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Date"
                        variant="outlined"
                        onKeyDown={(e) => e.preventDefault()}
                        sx={{ width: "15dvw", marginLeft: "1vw" }}
                        size="small"
                    />
                )}
            />
        </LocalizationProvider>
    );

    return (
        <CounsellorDateContext.Provider value={{ filterDate, setFilterDate }}>
            <Box sx={{ height: "85vh", width: "100%", backgroundColor: Colors.Background, p: 1 }}>
                <Box sx={{ mb: 0.5 }}>
                    <Typography variant="h6" ml={2} fontWeight={500}>
                        Counsellor Home
                    </Typography>
                </Box>
                <CommonTabs
                    {...props}
                    List={List}
                    selectedTab={selectedTab}
                    BackToHome={null}
                    headerRightContent={datePicker}
                    history={history}
                />
            </Box>
        </CounsellorDateContext.Provider>
    );
};

export default CounsellorHomeWrapper;
